import React from 'react'
import OAuthApplicationForm from '../../forms/OAuthApplicationForm'
import {connect} from 'react-redux'
import {initialize, isDirty, getFormInitialValues, getFormSyncErrors} from 'redux-form'
import * as api from '../../api'
import {notificationSuccess, notificationError, notificationLoading} from '../../actions/notification/notification'
import _ from 'lodash'
import {withRouter} from 'react-router'
import {init, showIDSecretModal, submitAction, setFormState} from '../../actions/oauthApplication'
import ApplicationIDSecretInfoModal from '../../frags/ApplicationIDSecretInfoModal'
import * as mpOauthForm from '../../mixpanel/oauth/form'

const defaultURLDropdownOptionValue = `https://`

class OAuthApplication extends React.Component {
  static FORM_STATES = ['credentials', 'scopes', 'app_information', 'screenshots']

  componentWillMount () {
    const {app, initForm, scopes} = this.props
    if (app.scopes.length === 0) {
      app.scopes = _.filter(scopes, (scope) => scope.required).map((scope) => scope.value)
    }
    initForm('app', {
      id: app.id,
      price: app.price,
      uid: app.uid,
      secret: app.secret,
      category: app.category,
      name: app.name,
      remote_logo_url: app.logo.url,
      short_description: app.short_description,
      description: app.description,
      redirect_uri: app.redirect_uri || defaultURLDropdownOptionValue,
      scopes: app.scopes.join(' '),
      website: (app.website) ? app.website : defaultURLDropdownOptionValue,
      support_phone: app.support_phone,
      support_email: app.support_email,
      oauth_application_images: app.oauth_application_images.map((img) => ({id: img.id, image: {url: img.image.url}}))
    })
  }

  componentDidMount () {
    window.onbeforeunload = this._onLeavePage
  }

  render () {
    const {app, scopes, categories, showIDSecretModal, formState, errors} = this.props
    return <div>
      <OAuthApplicationForm
        app={app}
        onSubmit={this._onSubmit}
        disableSubmit={this.props.loading}
        onClickCancel={this._onCancel}
        scopes={scopes}
        categories={categories}
        formState={formState}
        onClickBack={this._onClickBack}
        onClickNext={this._onClickNext}
        onClickBreadcrumb={this._onClickBreadcrumb}
        errors={errors}
      />
      <ApplicationIDSecretInfoModal
        app={app}
        show={showIDSecretModal}
        onClickConfirm={this._onConfirmIDSecretModal}
      />
    </div>
  }

  _onLeavePage = () => {
    return this.props.isDirty ? true : undefined
  }

  _onConfirmIDSecretModal = () => {
    // redirect to application pages
    const {history, actionState} = this.props
    const notif = actionState
    history.push({
      pathname: '/redirect',
      search: `?next=/oauth/applications&notif=${notif}`
    })
  }

  _onCancel = () => {
    const {history, app} = this.props
    mpOauthForm.cancel({id: app.id, uid: app.uid, name: app.name})
    setTimeout(function () {
      history.push({
        pathname: '/'
      })
    }, 500)
  }

  _onClickBack = () => {
    const {formState, setFormState, app} = this.props
    let match = 0
    for (let i = 1; i < OAuthApplication.FORM_STATES.length; i++) {
      if (formState === OAuthApplication.FORM_STATES[i]) {
        match = i
      }
    }
    setFormState(OAuthApplication.FORM_STATES[match - 1])
    mpOauthForm.back({step: match + 1, id: app.id})
  }

  _onClickNext = () => {
    const {formState, setFormState, app} = this.props
    let match = 0
    for (let i = 0; i < OAuthApplication.FORM_STATES.length - 1; i++) {
      if (formState === OAuthApplication.FORM_STATES[i]) {
        match = i
      }
    }
    setFormState(OAuthApplication.FORM_STATES[match + 1])
    mpOauthForm.next({step: match, id: app.id})
  }

  _onClickBreadcrumb = () => {
    const {app} = this.props
    mpOauthForm.breadcrumbStatus({id: app.id})
    setTimeout(function () {
      window.location = `/oauth/applications`
    }, 500)
  }

  _onSubmit = async (values) => {
    const {initialValues, categories, scopes, app} = this.props
    mpOauthForm.confirm({id: app.id, uid: app.uid, name: values.name})

    if (initialValues.remote_logo_url === values.remote_logo_url) {
      delete values.remote_logo_url
    }

    this.props.notifyLoading(true)

    try {
      let app, response
      if (values.id) {
        response = await api.patchOAuthApp({id: values.id, data: values})
        this.props.submitAction('application_updated')
      } else {
        response = await api.postOAuthApp({data: values})
        this.props.submitAction('application_created')
      }
      app = response.data.data.app
      this.props.init({app, categories, scopes})
      this.props.initForm('app', {
        id: app.id,
        category: app.category,
        name: app.name,
        remote_logo_url: app.logo.url,
        short_description: app.short_description,
        description: app.description,
        redirect_uri: app.redirect_uri,
        scopes: app.scopes.join(' '),
        website: app.website,
        support_phone: app.support_phone,
        support_email: app.support_email,
        oauth_application_images: app.oauth_application_images.map((img) => ({id: img.id, image: {url: img.image.url}}))
      })
      this.props.notifyLoading(false)

      // redirect to application pages
      const {history, actionState} = this.props
      history.push({
        pathname: '/redirect',
        search: `?next=/oauth/applications&notif=${actionState}`
      })
    } catch (error) {
      this.props.notifyError(error.data.meta.errors.error_message)
      this.props.notifyLoading(false)
    } finally {
    }
  }
}

function mapStateToProps (state) {
  return {
    app: state.app.app,
    categories: state.app.categories,
    scopes: state.app.scopes,
    showIDSecretModal: state.app.showIDSecretModal,
    actionState: state.app.submitAction,
    formState: state.app.formState,
    isDirty: isDirty('app')(state),
    initialValues: getFormInitialValues('app')(state),
    loading: state.notification.loading,
    errors: getFormSyncErrors('app')(state)
  }
}

function mapDispatchToProps (dispatch) {
  return {
    init: (...args) => {
      dispatch(init(...args))
    },
    submitAction: (action) => {
      dispatch(submitAction({action}))
    },
    openModal: () => {
      dispatch(showIDSecretModal())
    },
    initForm: (...args) => {
      dispatch(initialize(...args))
    },
    notifyLoading: (loading) => {
      dispatch(notificationLoading({loading}))
    },
    notifySuccess: (message) => {
      dispatch(notificationSuccess({message}))
    },
    notifyError: (message) => {
      dispatch(notificationError({message}))
    },
    setFormState: (state) => {
      dispatch(setFormState({state}))
    }
  }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(OAuthApplication))



// WEBPACK FOOTER //
// app/javascript/components/pages/OAuthApplication/OAuthApplication.js